import { ApiMutation } from "@/hooks/use-api-mutation"
import { AuthenticationJSON, ICompleteChallengeResponse, PasskeyResponseType, RegistrationJSON } from "@portafino/shared"

interface Input {
    credential: RegistrationJSON | AuthenticationJSON
    type: PasskeyResponseType
    challenge: string
  }

export const CompleteTenantUserChallenge: ApiMutation<ICompleteChallengeResponse, Input> = {
    mutationFn: async (apiClient, { credential, type, challenge }) => {
        const payload = {
            type,
            ...(type === PasskeyResponseType.REGISTRATION ? {
                registrationData: credential
            } : {
                authenticationResponse: credential
            }),
            sessionId: challenge,
        }
        const { data } = await apiClient.post<ICompleteChallengeResponse, typeof payload>('/tenants/auth/complete-challenge', payload)
        return data
    }
}
